import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, ClockIcon, VideoIcon, CheckCircle2Icon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ReviewsGallery } from '../components/ReviewsGallery';
export function WorkshopPage() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="pt-[64px] md:pt-[72px]" data-id="element-1373">
      {/* SECȚIUNEA 1 — HERO EVENIMENT */}
      <section className="bg-brand-beige section-padding" data-id="element-1374">
        <div className="container-custom" data-id="element-1375">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1376">
            <span className="inline-block px-4 py-1.5 rounded-full bg-red-100 text-red-600 font-montserrat font-bold text-[12px] tracking-wider uppercase mb-6" data-id="element-1377">
              WORKSHOP ONLINE GRATUIT
            </span>
            <h1 className="font-playfair text-[40px] md:text-[56px] font-bold text-brand-navy mb-6 leading-tight" data-id="element-1378">
              Cum îți ajuți copilul să vorbească și să se dezvolte, prin joc,
              acasă
            </h1>
            <p className="font-source text-[18px] text-brand-textSecondary mb-10 max-w-3xl mx-auto" data-id="element-1379">
              Pentru mamele de copii între 1 și 4 ani care nu vorbesc sau
              vorbesc prea puțin. Descoperi ce e normal și ce nu la vârsta lui,
              ce poți face concret acasă și care sunt greșelile care încetinesc
              progresul fără să îți dai seama.
            </p>

            <div className="bg-white p-6 rounded-[24px] shadow-sm border border-gray-100 flex flex-col md:flex-row items-center justify-center gap-8 mb-10 max-w-2xl mx-auto" data-id="element-1380">
              <div className="flex items-center gap-3" data-id="element-1381">
                <CalendarIcon className="text-brand-coral" size={24} data-id="element-1382" />
                <div className="text-left" data-id="element-1383">
                  <p className="font-montserrat font-bold text-[14px] text-brand-navy" data-id="element-1384">
                    Data și ora
                  </p>
                  <p className="font-source text-[14px] text-brand-textSecondary" data-id="element-1385">
                    A se anunța
                  </p>
                </div>
              </div>
              <div className="hidden md:block w-px h-10 bg-gray-200" data-id="element-1386"></div>
              <div className="flex items-center gap-3" data-id="element-1387">
                <VideoIcon className="text-brand-coral" size={24} data-id="element-1388" />
                <div className="text-left" data-id="element-1389">
                  <p className="font-montserrat font-bold text-[14px] text-brand-navy" data-id="element-1390">
                    Platformă
                  </p>
                  <p className="font-source text-[14px] text-brand-textSecondary" data-id="element-1391">
                    Online, pe Zoom
                  </p>
                </div>
              </div>
              <div className="hidden md:block w-px h-10 bg-gray-200" data-id="element-1392"></div>
              <div className="flex items-center gap-3" data-id="element-1393">
                <ClockIcon className="text-brand-coral" size={24} data-id="element-1394" />
                <div className="text-left" data-id="element-1395">
                  <p className="font-montserrat font-bold text-[14px] text-brand-navy" data-id="element-1396">
                    Durată
                  </p>
                  <p className="font-source text-[14px] text-brand-textSecondary" data-id="element-1397">
                    90 minute
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center gap-3" data-id="element-1398">
              <a href="#register" className="btn-primary" data-id="element-1399">
                Click aici pentru înscriere!
              </a>
              <p className="font-source text-[14px] text-brand-textSecondary" data-id="element-1400">
                Workshop-ul este online, pe Zoom, iar locurile sunt limitate.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 2 — PROBLEMĂ */}
      <section className="bg-brand-ivory section-padding" data-id="element-1401">
        <div className="container-custom" data-id="element-1402">
          <div className="max-w-3xl mx-auto" data-id="element-1403">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy mb-8 text-center" data-id="element-1404">
              Ce se întâmplă când aștepți și cauți răspunsuri la întâmplare...
            </h2>
            <div className="font-source text-[16px] md:text-[18px] text-brand-text space-y-6 mb-10" data-id="element-1405">
              <p data-id="element-1406">
                Te trezești dimineața și prima grijă e legată de copilul tău. Nu
                vorbește sau spune doar câteva cuvinte pe care le înțelegi doar
                tu.
              </p>
              <p data-id="element-1407">
                Ai căutat pe Google, ai citit pe grupuri de Facebook, ai
                descărcat ghiduri gratuite. Dar tot nu știi ce e normal și ce
                nu.
              </p>
              <p data-id="element-1408">
                Soțul îți spune că exagerezi. Soacra îți amintește că "și tatăl
                lui a vorbit mai târziu". Tu asculți, dar în interior simți că
                ceva nu e în regulă.
              </p>
              <p data-id="element-1409">
                Ai cumpărat un curs care nu a funcționat. Nimeni nu te-a
                supervizat. Te întrebi dacă ai aplicat greșit sau pur și simplu
                nu se potrivea copilului tău.
              </p>
              <p data-id="element-1410">
                Te sperie gândul că pierzi timp prețios cu soluții greșite, dar
                te sperie și gândul că poate ai nevoie de un specialist și nu
                ești pregătită să auzi ce ți-ar spune.
              </p>
              <p data-id="element-1411">
                Între timp, copilul tău crește. Și fereastra în care poți face
                cea mai mare diferență se îngustează cu fiecare lună care trece.
              </p>

              <div className="bg-white p-6 rounded-[16px] border-l-4 border-brand-coral mt-8" data-id="element-1412">
                <p className="font-source text-[18px] text-brand-navy font-medium" data-id="element-1413">
                  Am văzut această poveste de sute de ori în cei peste 11 ani de
                  lucru cu copii mici și cu familiile lor. Și am văzut cum se
                  schimbă totul când mama primește informația corectă și un plan
                  clar. De aceea am creat acest workshop gratuit, la care te
                  invit și pe tine.
                </p>
              </div>
            </div>

            <div className="text-center" data-id="element-1414">
              <a href="#register" className="btn-primary" data-id="element-1415">
                Click aici pentru înscriere!
              </a>
              <p className="font-source text-[14px] text-brand-textSecondary mt-3" data-id="element-1416">
                Workshop-ul este online, pe Zoom, iar locurile sunt limitate.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 3 — CE VEI ÎNVĂȚA */}
      <section className="bg-brand-navy section-padding text-white" data-id="element-1417">
        <div className="container-custom" data-id="element-1418">
          <div className="max-w-4xl mx-auto" data-id="element-1419">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-white mb-10 text-center" data-id="element-1420">
              Ce vei descoperi concret în cele 90 de minute
            </h2>
            <div className="space-y-6 mb-12" data-id="element-1421">
              {['Vei înțelege care sunt etapele reale de dezvoltare ale unui copil între 1 și 4 ani și ce ar trebui să facă copilul tău la vârsta lui, ca să nu te mai bazezi pe păreri de pe internet.', 'Vei învăța să deosebești o variație normală de dezvoltare de o întârziere care necesită atenție, fără să te panichezi și fără să amâni inutil.', 'Vei descoperi de ce cursurile cumpărate până acum nu au funcționat și ce le-a lipsit ca să dea rezultate pentru copilul tău.', 'Vei primi primele tehnici simple de stimulare a limbajului prin joc, pe care le poți aplica acasă, chiar din seara în care participi la workshop.', 'Vei înțelege de ce ecranele încetinesc dezvoltarea și ce poți face concret ca să reduci impactul, fără să te simți vinovată.', 'Vei ști când e suficient să lucrezi acasă cu copilul tău și când e momentul să ceri ajutor profesional, ca să nu mai pierzi timp cu soluții care nu se potrivesc.'].map((item, i) => <div key={i} className="flex items-start gap-4 bg-white/5 p-6 rounded-[16px] border border-white/10" data-id="element-1422">
                  <div className="w-8 h-8 rounded-full bg-brand-gold text-brand-navy flex items-center justify-center flex-shrink-0 font-bold font-montserrat mt-0.5" data-id="element-1423">
                    {i + 1}
                  </div>
                  <p className="font-source text-[16px] md:text-[18px] text-white/90" data-id="element-1424">
                    {item}
                  </p>
                </div>)}
            </div>
            <div className="text-center" data-id="element-1425">
              <a href="#register" className="btn-inverted" data-id="element-1426">
                Click aici pentru înscriere!
              </a>
              <p className="font-source text-[14px] text-white/60 mt-3" data-id="element-1427">
                Workshop-ul este online, pe Zoom, iar locurile sunt limitate.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 4 — CUM SE VA SCHIMBA VIAȚA TA */}
      <section className="bg-brand-beige section-padding" data-id="element-1428">
        <div className="container-custom" data-id="element-1429">
          <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy text-center mb-12" data-id="element-1430">
            Ce se schimbă după acest workshop
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-1431">
            {[{
            title: 'Claritate și liniște',
            desc: 'Nu te mai sperii de fiecare articol citit pe internet. Știi exact unde e copilul tău, ce e normal și ce necesită atenție. Ai un reper clar pe care te poți baza.'
          }, {
            title: 'Primii pași concreți',
            desc: 'Pleci de la workshop cu tehnici simple pe care le poți aplica imediat, acasă, în rutinele zilnice, fără jucării scumpe și fără să adaugi ore suplimentare în programul tău.'
          }, {
            title: 'Încredere ca mamă',
            desc: 'Nu mai aștepți validare de la soț, de la soacră sau de la grupuri de Facebook. Știi ce faci, de ce faci și ai un plan clar pentru copilul tău.'
          }].map((card, i) => <div key={i} className="bg-white p-8 rounded-[24px] shadow-sm border-t-4 border-brand-coral" data-id="element-1432">
                <h3 className="font-montserrat font-bold text-[20px] text-brand-navy mb-4" data-id="element-1433">
                  {card.title}
                </h3>
                <p className="font-source text-[16px] text-brand-text" data-id="element-1434">
                  {card.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 5 — CINE SUNT EU */}
      <section className="bg-brand-ivory section-padding" data-id="element-1435">
        <div className="container-custom" data-id="element-1436">
          <div className="max-w-4xl mx-auto" data-id="element-1437">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy text-center mb-10" data-id="element-1438">
              Cine sunt eu și de ce am creat acest workshop gratuit
            </h2>
            <div className="grid md:grid-cols-3 gap-8 items-stretch" data-id="element-1439">
              <div className="md:col-span-1" data-id="element-1440">
                <img src="https://cdn.magicpatterns.com/uploads/wvUBHAy6VhqaRqNiVJPB6X/Cristina_poze_%285%29.jpg" alt="Cristina Geană" className="w-full h-full object-cover object-top rounded-[24px] shadow-card" data-id="element-1441" />
              </div>
              <div className="md:col-span-2 font-source text-[16px] md:text-[18px] text-brand-text space-y-4" data-id="element-1442">
                <p data-id="element-1443">
                  Sunt Cristina Geană, psiholog clinician cu peste 11 ani de
                  experiență directă cu copii mici. Am lucrat cu sute de copii
                  cu întârzieri în dezvoltare și tulburări din spectrul autist,
                  iar astăzi coordonez o echipă de 21 de specialiști într-un
                  centru de psihologie și terapie.
                </p>
                <p data-id="element-1444">
                  Sunt formată în Analiză Comportamentală (ABA) la Universitatea
                  Clemson din SUA, atestată în psihologie clinică și
                  psihoterapie cognitiv-comportamentală, și am zeci de cursuri
                  în logopedie, terapie de integrare senzorială și evaluarea
                  copilului cu cerințe educative speciale.
                </p>
                <p data-id="element-1445">
                  Am creat acest workshop gratuit pentru că văd în fiecare zi
                  mame care pierd luni prețioase căutând soluții pe internet,
                  cumpărând cursuri care nu funcționează și ascultând sfaturi
                  contradictorii. Am vrut să ofer un loc în care orice mamă
                  poate primi informația corectă, de la un specialist, fără
                  bariere de preț.
                </p>
                <p className="font-bold text-brand-navy" data-id="element-1446">
                  Sunt și eu mamă a doi băieți. Știu exact cum e să te
                  îngrijorezi pentru copilul tău. Și știu ce diferență face când
                  ai pe cineva care te ghidează clar.
                </p>
              </div>
            </div>
            <div className="text-center mt-10" data-id="element-1447">
              <a href="#register" className="btn-primary" data-id="element-1448">
                Click aici pentru înscriere!
              </a>
              <p className="font-source text-[14px] text-brand-textSecondary mt-3" data-id="element-1449">
                Workshop-ul este online, pe Zoom, iar locurile sunt limitate.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 6 — PENTRU CINE ESTE / NU ESTE */}
      <section className="bg-brand-beige section-padding" data-id="element-1450">
        <div className="container-custom" data-id="element-1451">
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-1452">
            <div className="bg-white p-8 rounded-[24px] shadow-sm" data-id="element-1453">
              <h3 className="font-playfair text-[28px] font-bold text-brand-navy mb-6" data-id="element-1454">
                Pentru cine este acest workshop?
              </h3>
              <ul className="space-y-4" data-id="element-1455">
                {['Mame de copii între 1 și 4 ani care nu vorbesc sau vorbesc foarte puțin și care vor să înțeleagă dacă e normal sau dacă trebuie să acționeze acum', 'Mame care au observat că copilul lor a fost supraexpus la ecrane și care văd diferențe față de alți copii de aceeași vârstă, dar nu știu ce să facă', 'Mame ai căror copii au primit recent un diagnostic (autism, întârziere în dezvoltare) și care vor să știe ce pot face acasă, pe lângă terapia din centru', 'Mame de copii între 1 și 2 ani care vor să prevină întârzierile și să stimuleze dezvoltarea corect de la început'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1456">
                    <CheckCircle2Icon className="text-brand-gold flex-shrink-0 mt-0.5" size={20} data-id="element-1457" />
                    <span className="font-source text-[15px] text-brand-text" data-id="element-1458">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-white p-8 rounded-[24px] shadow-sm" data-id="element-1459">
              <h3 className="font-playfair text-[28px] font-bold text-brand-navy mb-6" data-id="element-1460">
                Pentru cine NU este acest workshop?
              </h3>
              <ul className="space-y-4" data-id="element-1461">
                {['Mame care caută o soluție magică și rapidă, fără să fie dispuse să lucreze zilnic cu copilul lor', 'Mame care sunt sigure că copilul lor nu are nicio problemă și caută doar confirmare că "o să treacă de la sine"', 'Profesioniști care caută un curs de specialitate. Acest workshop este creat pentru mame, în limbaj accesibil, nu pentru terapeuți'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1462">
                    <div className="w-5 h-5 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1463">
                      <span className="w-1.5 h-1.5 rounded-full bg-gray-500" data-id="element-1464"></span>
                    </div>
                    <span className="font-source text-[15px] text-brand-text" data-id="element-1465">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 7 — TESTIMONIALE */}
      <section className="bg-brand-ivory section-padding" data-id="element-1466">
        <div className="container-custom" data-id="element-1467">
          <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy text-center mb-12" data-id="element-1468">
            Ce spun mamele care au lucrat deja cu mine
          </h2>
          <ReviewsGallery data-id="element-1469" />
        </div>
      </section>

      {/* SECȚIUNEA 8 — CTA FINAL */}
      <section id="register" className="bg-brand-navy section-padding text-center text-white" data-id="element-1470">
        <div className="container-custom" data-id="element-1471">
          <div className="max-w-2xl mx-auto bg-white/10 backdrop-blur-sm p-8 md:p-12 rounded-[24px] border border-white/20" data-id="element-1472">
            <h2 className="font-playfair text-[32px] font-bold text-white mb-8" data-id="element-1473">
              Formular de înscriere
            </h2>
            {/* Placeholder for actual form */}
            <div className="space-y-4 mb-8 text-left" data-id="element-1474">
              <input type="text" placeholder="Numele tău" className="w-full px-4 py-3 rounded-[12px] border-none focus:ring-2 focus:ring-brand-gold text-brand-navy" data-id="element-1475" />
              <input type="email" placeholder="Adresa de email" className="w-full px-4 py-3 rounded-[12px] border-none focus:ring-2 focus:ring-brand-gold text-brand-navy" data-id="element-1476" />
            </div>
            <button className="btn-inverted w-full text-[16px] py-4" data-id="element-1477">
              Înscrie-te ACUM la Workshop - Este GRATUIT
            </button>
            <p className="font-source text-[14px] text-brand-gold mt-4 font-medium" data-id="element-1478">
              Locurile sunt limitate de capacitatea Zoom. Înscrie-te acum ca să
              îți rezervi locul.
            </p>
          </div>
        </div>
      </section>
    </motion.div>;
}